module.exports = __webpack_public_path__ + "static/assets/37087f4dc6b36c4e67a85e91416a4709.svg";